import { Link } from 'react-router';
import { experienceRegionLabels, type ExperienceType } from '@/types/types_experience';
import { formatPrice } from '@/util/util_format';

interface ExperienceCardProps {
  experience: ExperienceType;
}

/** A single experience card for the public catalog grid. */
export function ExperienceCard({ experience }: ExperienceCardProps) {
  return (
    <Link
      to={`/experiences/${experience.id}`}
      className='tw:group tw:flex tw:flex-col tw:overflow-hidden tw:border tw:border-ed-black/10 tw:bg-white tw:transition-shadow tw:hover:shadow-xl'
    >
      <div className='tw:relative tw:aspect-[4/3] tw:overflow-hidden'>
        <img
          src={experience.heroImage}
          alt={experience.name}
          loading='lazy'
          className='tw:h-full tw:w-full tw:object-cover tw:transition-transform tw:duration-700 tw:group-hover:scale-105'
        />
        <span className='tw:absolute tw:left-4 tw:top-4 tw:bg-ed-cream/90 tw:px-3 tw:py-1 tw:text-[0.65rem] tw:tracking-[0.2em] tw:uppercase tw:text-ed-umber'>
          {experienceRegionLabels[experience.region]}
        </span>
      </div>

      <div className='tw:flex tw:flex-1 tw:flex-col tw:p-6'>
        <p className='tw:text-xs tw:tracking-[0.2em] tw:uppercase tw:text-ed-gold'>{experience.subtitle}</p>
        <h3 className='tw:mt-2 tw:font-serif tw:text-2xl tw:leading-tight tw:text-ed-black'>{experience.name}</h3>
        <p className='tw:mt-3 tw:flex-1 tw:text-sm tw:leading-relaxed tw:text-ed-charcoal/80'>
          {experience.shortDescription}
        </p>
        <div className='tw:mt-5 tw:flex tw:items-center tw:justify-between tw:border-t tw:border-ed-black/10 tw:pt-4'>
          <span className='tw:text-sm tw:text-ed-umber'>{experience.venueName}</span>
          <span className='tw:font-serif tw:text-lg tw:text-ed-black'>{formatPrice(experience.basePrice)}</span>
        </div>
      </div>
    </Link>
  );
}
